import BankAccountDetail from './BankAccountDetail';

export default BankAccountDetail;
